<template>
  <Teleport to="body">
    <main class="logout-page" aria-live="polite">
      <LoadingIndicator message="Logging out…" />
    </main>
  </Teleport>
  <iframe :src="rfiURL" width="1" height="1" />
</template>

<script setup lang="ts">

import {computed, onMounted} from 'vue';
import Auth from "@/auth";
import LoadingIndicator from '@/components/LoadingIndicator.vue';

const rfiURL = computed(() => `${import.meta.env.VITE_RFI_APP_URL}logout`);

onMounted(() => {
  window.setTimeout(() => Auth.logout(), 250);
});

</script>

<style lang="scss" scoped>
  .logout-page {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    inset: 0;
    justify-content: center;
    position: fixed;
  }

  iframe {
    border: 0;
    position: absolute;
  }
</style>
